<template>
     <div class="pay-method-detail" >
        <div>
            <div id="square-sdk-container"></div>
        </div>
                
        <div class="row">
            <fieldset class="col-lg-6">
                <input id="input-cardholder-fname" class="form-control" type="text" placeholder="First name" 
                v-model="first_name" :required="true"/>
                <label for="input-cardholder-fname" class="form-label">First Name</label>
            </fieldset>

            <fieldset class="col-lg-6">
                <input id="input-cardholder-lname" class="form-control" type="text" placeholder="Last name" 
                v-model="last_name" :required="true"/>
                <label for="input-cardholder-lname" class="form-label">Last Name</label>
            </fieldset>
        </div>

        <input id="input-cardholder-email" class="form-control" type="email" placeholder="Cardholder Email" 
        v-model="email" :required="true"/>
        <label for="input-cardholder-email" class="form-label">Cardholder Email</label>
    </div>
</template>

<script>
export default {

    props: {
        value: {
            type: Object,
            required: true,
            default(data={}) {
                return {
                    first_name: data.first_name ?? '',
                    last_name: data.last_name ?? '',
                    email: data.email ?? '',
                };
            }
        }
    },

    data() {
        return {
            first_name: '',
            last_name: '',
            email: '',

            card: null,
            token: null,
        }
    },

    async mounted() {
        const url = this.$root.square.sandbox ? 'https://sandbox.web.squarecdn.com/v1/square.js' : 'https://web.squarecdn.com/v1/square.js';
        console.log(url);
        const squarePromise = new Promise((resolve, reject) => {
            if (window.Square === null || !window.Square) {
                const el = document.createElement('script');
                el.src = url;
                el.async = true;
                el.defer = true;
                document.head.appendChild(el);

                el.addEventListener('load', () => {
                    console.debug('Loaded square');
                    resolve(window.Square);
                });
            } else {
                resolve(window.Square);
            }
        });

        squarePromise.then(async (sq) => {
            // Initialize Square elements
            if (!window.Square) {
                console.warn('Square.js failed to load.');
                throw new Error('Square.js failed to load properly');
            }
            
            if (!this.$root.square.app_id || !this.$root.square.loc_id) {
                console.warn('Square account details not found');
                throw new Error('Square account details not found');
            }

            let payments = window.Square.payments(this.$root.square.app_id, this.$root.square.loc_id);

            try {
                this.card = await this.sqInitializeCard(payments);
            } catch (error) {
                console.error('Initializing Card failed');
                console.error(error);
                return;
            }
        })
        .catch((er) => {
            console.error(er);
        })

        this.$emit('paytype', this.payment_type);
    },

    methods: {
        // Attach the CC form the the provided DIV
        async sqInitializeCard(payments) {
            const card = await payments.card();
            await card.attach('#square-sdk-container'); 
            return card; 
        },

        // This function tokenizes a payment method. 
        // The ‘error’ thrown from this async function denotes a failed tokenization,
        // which is due to buyer error (such as an expired card). It is up to the
        // developer to handle the error and provide the buyer the chance to fix
        // their mistakes.
        async sqTokenize(paymentMethod) {
            window.Square.payments.contact
            const tokenResult = await paymentMethod.tokenize();
            if (tokenResult.status === 'OK') {
                return tokenResult.token;
            } else {
                let errorMessage = `Tokenization failed-status: ${tokenResult.status}`;
                if (tokenResult.errors) {
                    errorMessage += ` and errors: ${JSON.stringify(
                        tokenResult.errors
                    )}`;
                }
                throw new Error(errorMessage);
            }
        },

        async submitCard() {
            this.token = await this.sqTokenize(this.card);
            await this.handleInput();
        },

        async handleInput() {
            const data = {
                first_name: this.first_name,
                last_name: this.last_name,
                email: this.email,
                token: this.token
            };

            this.$emit('input', data);
        },

    },

}
</script>